<template>

 <div class="mainMenus" >

  
    <div class="Contentframe" >
     
        <div class="leftmenu">
          <LeftMenus  :styles="styles" :active="active" :infoID="$route.query.infoID"></LeftMenus>
       </div>
 
        <div class="rightContent"> 
           
               
                 <el-input v-model="query" style="width:300px"  @keyup.enter.native="search"></el-input> <el-button @click="search">搜索</el-button><span v-if="max!=''" style="margin-left:30px">查询到记录数：{{max}}</span>
                <el-button @click="getAllLuncene" v-show="false">添加所有索引</el-button>
                <el-table
                  :data="resultList"
                  stripe
                  style="width: 100%"
                  @row-click="toRouter">
                  <el-table-column
                    width="600px">
                    <template slot-scope="scope">
                      <div><span  v-html="scope.row.content" @click="toRouter(scope.row)"></span></div>
                    </template>
                    <!-- <div v-for="(lists,index) in resultList" :key="index" ><span  v-html="lists.content"></span></div> -->
                  </el-table-column>
                  <el-table-column
                    prop="createDate"
                    width="280">
                  </el-table-column>
                
                </el-table>

   
    
        </div>

   </div>
   </div>
  

  
    </template>
    
    <script>
        import LeftMenus from './LeftMenus.vue'
    export default {
       components:{LeftMenus},
      created(){
         this.selectAnnouncement()
      },
    data() {
          return {
            announcement:[],
            query:'',
            values:'',
            resultList:[],
            styles:[],
            active:[],
            infoList:[],
            max:'',
          }
        },
    mounteds:{
     
    },methods:{
      selectAnnouncement(){
    //     this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    // .then(resp => { 
    //                   if(resp.data.status == 1) {      
    //                     this.info=resp.data.result[0]                                                
    //                                console.log(resp.data.result[0])   
    //                                this.infoList=resp.data.result[0]   
    //                             }else {
    //                                alert("拿取数据失败")                                 
    //                             }
    //                         })
    //                         .catch((err) => {
    //                            // alert("出错了")
    //                             console.log(err)
    //                         })  


    


      this.active=this.$route.query.active
       this.styles=this.$route.query.styles   

      },search(){
        this.axios.post("/lucen/lucen?query="+this.query)
         .then(resp => { 
                       if(resp.data.status == 1) {
                        this.max=resp.data.result[resp.data.result.length-1].score
                        // resp.data.result.length=resp.data.result.length-1
                        this.resultList=resp.data.result
                        this.$message.success("成功")
                                // this.announcement=resp.data.result
                                }else {
                                this.$message.error(resp.data.message)                   
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      },getAllLuncene(){
        this.axios.post("/lucen/getAllData")
         .then(resp => { 
                       if(resp.data.status == 1) {
                        this.$message.success("成功")
                                }else {
                                this.$message.error(resp.data.message)                   
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      },toRouter(data){
        // this.$router.push({  //核心语句
        //             name: data.router,   //跳转的路径
        //             query:{'announcementId':data.announcementId}
        //           })
    console.log(data)
    if(data.type=="ThreeInfo"||data.type=="TwoInfo"){
       let{ href } =   this.$router.resolve({  //核心语句
                    path: '/'+data.router,   //跳转的路径
                    query:{'htmlpath':data.filePath,'styles':'null','infoID':data.superiorsId}
                  })
                  window.open(href, '_blank')    
    }else if(data.type=="FourInfo"){
      let{ href } =    this.$router.resolve({  //核心语句
                    path: '/'+data.router,   //跳转的路径
                    query:{'htmlpath':data.filePath,'styles':'null','infoID':data.superiorsId}
                  })
                  window.open(href, '_blank')   
    }else if(data.type=="news"){
      let{ href } =  this.$router.resolve({  //核心语句
                    path: '/news',   //跳转的路径
                    query:{'newsid':data.id,newsHtmlURL:data.filePath}
                  })
                  window.open(href, '_blank')   
    }
console.log(data)
      }
    }
      
    
    }
    </script>
    
    <style scoped>
    
    .leftmenu
   {
     padding-left:15px;
       background:#0065bd;
     color:black;
     margin-top: 40px;
     margin-right: 20px;
     height:500px;
     width:20%;
     padding: 20px;
     box-shadow: 0px 0px 2px #ededed;
   }
  .rightContent{
  width: 80%;
  margin-left:50px;
  margin-top: 50px;


}
 .mainMenus{
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}

.Contentframe{
  width: 90%;
  margin: auto;
  display: flex;
 
}
    </style>
    
    
    
    


// WEBPACK FOOTER //
// src/components/work/Sear.vue